import { ITiresCombinationWithPartialTire } from '../container-modal/ScheduleModal'
import styles from './styles.module.css'

function formatTireSize(item: Partial<ITiresCombinationWithPartialTire>) {
  const { frontTire, rearTire } = item
  return {
    frontSize: `${frontTire.width} | ${frontTire.aspectRatio} R${frontTire.diameter}`,
    rearSize: `${rearTire.width} | ${rearTire.aspectRatio} R${rearTire.diameter}`,
  }
}

interface IOrderSummaryProps {
  tiresCombination: Partial<ITiresCombinationWithPartialTire>
  isRework: boolean
}

export default function OrderSummary({
  tiresCombination,
  isRework,
}: IOrderSummaryProps) {
  const tire = formatTireSize(tiresCombination)


  return (
    <div className={styles.orderSummaryContainer}>
      <div className={styles.orderSummaryLabel}>Order Summary</div>
      <div className={styles.breakdownsContainer}>
        <div className={styles.serviceAndTireSummariesContainer}>
          <div className={styles.serviceSummaryContainer}>
            <div className={styles.serviceSummaryLabel}>Service Summary</div>
            <div className={styles.tireInstallationLabel}>{isRework ? 'Rework' : 'Tire Installation'}</div>
          </div>
          <div className={styles.tireSummaryContainer}>
            <div className={styles.tireSummaryLabel}>Tire Summary</div>
            <div className={styles.servicesContainer}>
              <div className={styles.line}></div>
              <div className={styles.serviceContainer}>
                <div className={styles.tireSizeLabel}>Front Tire: </div>
                <div className={styles.tireSizeLabel}>{tire.frontSize}</div>
                <div className={styles.tireSizeLabel}>{tiresCombination.frontCount}</div>
              </div>
              <div className={styles.line}></div>
              <div className={styles.serviceContainer}>
                <div className={styles.tireSizeLabel}>Rear Tire: </div>
                <div className={styles.tireSizeLabel}>{tire.rearSize}</div>
                <div className={styles.tireSizeLabel}>{tiresCombination.rearCount}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
